import { useStore } from 'reactflow'
import { getViewportZoom } from './nodes/shared/viewportZoom'

/**
 * Zoomed far out, the full node UI is too small to read — a 400px designer card
 * is about 144px wide at 36% — but it still builds all the same HTML: wrappers,
 * panels, variants strips, labels, hover targets. On the 405-node stress
 * fixture that was 16,003 elements with the full card vs 9,766 with the simple
 * one, and a first-pan worst frame of 99.9ms vs 33.4ms.
 *
 * So below this zoom, idle nodes fall back to `FlatIdleNodeCard`. Above it,
 * where the detail is actually legible, they keep the full card.
 *
 * The `Lightweight idle node chrome` setting is unchanged and still means
 * "always use the simple card, at any zoom" — this only adds an automatic floor.
 */
export const CANVAS_ZOOM_LOD_THRESHOLD = 0.36

/**
 * True while the canvas is zoomed out past {@link CANVAS_ZOOM_LOD_THRESHOLD}.
 *
 * The selector returns a boolean rather than the zoom number, so the caller
 * re-renders only when the answer changes — not on every frame of a zoom.
 * Must be called under a `<ReactFlowProvider>`.
 */
export function useLowZoomNodeChromeLod(): boolean {
  return useStore((state) => getViewportZoom(state) < CANVAS_ZOOM_LOD_THRESHOLD)
}
